import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"
import { europcarCompaniesFilter, europcarUsersFilter } from "Pages/BusinessLogistics/Analytics/Page/@signals"
import React from "react"

export default function EuropcarUserSelector() {

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		urlAjax={`${BACKEND_APIS.EUROPCAR_ANALYTICS}/users`}
		value={europcarUsersFilter.value}
		onChange={(({ target }) => europcarUsersFilter.value = target.value)}
		label="Users"
		placeholder="Select a user to filter"
		filters={{
			users: europcarUsersFilter.value,
			company: europcarCompaniesFilter.value,
		}}
	/>
}